  export const environment = {
  production: false,
  apiUrl: 'https://main-api.e-hytec.dev/api',
  virtualTourVideoUrl: 'https://res.cloudinary.com/dv6n6hnxd/video/upload/v1775800136/ZyberHub-Comp_jlbz9l.mp4',
};
